import { Store } from './Scale'
import { initialState } from '../../utils/initialState'
import { FormValues } from './types'

type Payload = string

export function updateAction(state: Store, payload: FormValues): Store {
  return {
    ...state,
    inquery: {
      ...state.inquery,
      answers: { ...state.inquery.answers, ...payload },
      activeIndex: state.inquery.activeIndex + 1,
    },
  }
}
export function backwardsAction(state: Store): Store {
  return {
    ...state,
    inquery: {
      ...state.inquery,
      activeIndex: state.inquery.activeIndex - 1,
    },
  }
}

export function resetAction(): Store {
  return initialState
}

export function swicthContrast(state: Store): Store {
  return {
    ...state,
    inquery: {
      ...state.inquery,
      contrast: !state.inquery.contrast,
    },
  }
}

export function setFormInitialValues(state: Store, payload: FormValues): Store {
  return {
    ...state,
    inquery: {
      ...state.inquery,
      defaultValues: { ...state.inquery.defaultValues, ...payload },
    },
  }
}
